var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGidLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 132.045,
    height: 56.667,
    viewBox: "0 0 132.045 56.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#13aed3;}.b{fill:url(#a);}.c{fill:#fff;}.d{fill:#19446c;}.e{fill:url(#b);}.f{fill:url(#c);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.64,
    y1: 0.722,
    x2: 1.64,
    y2: 0.722,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2581c4",
    stopOpacity: 0.502
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2581c4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.001,
    y1: 0.5,
    x2: 1.001,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0099cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712,
    stopColor: "#08a8d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13aed3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#b"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.64 -1.96)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.64 1.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M30.816,1.96A28.176,28.176,0,1,1,2.64,30.136,28.175,28.175,0,0,1,30.816,1.96",
    transform: "translate(-2.64 -1.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 28.285,
    cy: 28.285,
    r: 28.285,
    transform: "translate(0 0.097)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.94 7.305)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M45.566,97.82a1.979,1.979,0,0,0-1.9,1.454H32.291a1.421,1.421,0,0,0-1.42,1.42v2.935a.37.37,0,0,1-.37.37H27.566a.37.37,0,0,1-.37-.37V101.7a1.98,1.98,0,1,0-1.053,0v1.927a1.421,1.421,0,0,0,1.42,1.42H30.5a1.421,1.421,0,0,0,1.42-1.42v-2.935a.37.37,0,0,1,.37-.37H43.662a1.977,1.977,0,1,0,1.9-2.5ZM25.841,99.8a.833.833,0,1,1,.833.833A.833.833,0,0,1,25.841,99.8Z",
    transform: "translate(-24.69 -83.651)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M61.035,125.39H53.379a1.421,1.421,0,0,0-1.42,1.42v2.935a.37.37,0,0,1-.37.37H49.662a1.98,1.98,0,1,0,0,1.053h1.927a1.421,1.421,0,0,0,1.42-1.42v-2.935a.37.37,0,0,1,.37-.37h7.657a.37.37,0,0,1,.37.37v17.1a.37.37,0,0,1-.37.37H59.109a1.98,1.98,0,1,0,0,1.053h1.927a1.421,1.421,0,0,0,1.42-1.42v-17.1A1.423,1.423,0,0,0,61.035,125.39Zm-3.828,20.251a.833.833,0,1,1,.833-.833A.833.833,0,0,1,57.207,145.641Z",
    transform: "translate(-41.056 -105.045)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M136.815,154.141a1.979,1.979,0,0,0-1.9,1.454h-1.927a.37.37,0,0,1-.37-.37V143.852a1.98,1.98,0,1,0-1.053,0v11.373a1.421,1.421,0,0,0,1.42,1.42h1.926a1.977,1.977,0,1,0,1.9-2.5Zm0,2.814a.833.833,0,1,1,.833-.833A.833.833,0,0,1,136.815,156.955Z",
    transform: "translate(-106.494 -116.359)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M146.269,58.183a1.979,1.979,0,0,0-1.9,1.454h-1.927a.37.37,0,0,1-.37-.37V56.333a1.421,1.421,0,0,0-1.42-1.42h-7.657a.37.37,0,0,1-.37-.37V42.169a.37.37,0,0,1,.37-.37h2.935a1.421,1.421,0,0,0,1.42-1.42V37.444a1.421,1.421,0,0,0-1.42-1.42H134a1.98,1.98,0,1,0,0,1.053h1.927a.37.37,0,0,1,.37.37v2.935a.37.37,0,0,1-.37.37h-2.935a1.421,1.421,0,0,0-1.42,1.42V54.55a1.421,1.421,0,0,0,1.42,1.42h7.657a.37.37,0,0,1,.37.37v2.935a1.421,1.421,0,0,0,1.42,1.42h1.927a1.978,1.978,0,1,0,1.9-2.511Zm0,2.814a.833.833,0,1,1,.833-.833A.833.833,0,0,1,146.269,61Z",
    transform: "translate(-106.502 -34.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M172.378,65.089a1.976,1.976,0,0,0-.526,3.882V70.9a.37.37,0,0,1-.37.37h-2.935a.37.37,0,0,1-.37-.37V67.963a1.421,1.421,0,0,0-1.42-1.42H159.1a.37.37,0,0,1-.37-.37V63.239a.37.37,0,0,1,.37-.37h7.657a1.421,1.421,0,0,0,1.42-1.42V58.514a1.421,1.421,0,0,0-1.42-1.42h-1.927a1.98,1.98,0,1,0,0,1.053h1.927a.37.37,0,0,1,.37.37v2.935a.37.37,0,0,1-.37.37H159.1a1.421,1.421,0,0,0-1.42,1.42v2.935a1.421,1.421,0,0,0,1.42,1.42h7.657a.37.37,0,0,1,.37.37V70.9a1.421,1.421,0,0,0,1.42,1.42h2.935a1.421,1.421,0,0,0,1.42-1.42V68.973a1.977,1.977,0,0,0-.524-3.884Zm-9.447-6.633a.833.833,0,1,1,.833-.833A.833.833,0,0,1,162.931,58.456Z",
    transform: "translate(-127.888 -50.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M66.975,34.57a1.979,1.979,0,0,0-1.9,1.454H63.147a1.421,1.421,0,0,0-1.42,1.42v2.935a1.421,1.421,0,0,0,1.42,1.42h2.935a.37.37,0,0,1,.37.37V45.1a.37.37,0,0,1-.37.37H53.7a.37.37,0,0,1-.37-.37V42.169a.37.37,0,0,1,.37-.37h1.927a1.98,1.98,0,1,0,0-1.053H53.7a1.421,1.421,0,0,0-1.42,1.42V45.1a1.421,1.421,0,0,0,1.42,1.42H66.079A1.421,1.421,0,0,0,67.5,45.1V42.166a1.421,1.421,0,0,0-1.42-1.42H63.145a.37.37,0,0,1-.37-.37V37.444a.37.37,0,0,1,.37-.37h1.927a1.977,1.977,0,1,0,1.9-2.5Zm0,2.814a.833.833,0,1,1,.833-.833A.833.833,0,0,1,66.975,37.384Z",
    transform: "translate(-46.099 -34.57)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.09 7.397)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M566.836,193a2.519,2.519,0,0,1,2.567,2.778v.069c0,.208-.081.255-.311.255H564.81a2.033,2.033,0,0,0,2.095,2.014,1.983,1.983,0,0,0,1.886-.983.445.445,0,0,1,.439.428c0,.381-.833,1.225-2.325,1.225a2.733,2.733,0,0,1-2.845-2.87A2.767,2.767,0,0,1,566.836,193Zm1.77,2.453a1.733,1.733,0,0,0-1.77-1.794,2.012,2.012,0,0,0-2,1.794Z",
    transform: "translate(-506.744 -155.641)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.574 0.685)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M484.86,30.91a1.62,1.62,0,0,1,1.622-1.62h7.3c9.509,0,15.1,5.074,15.1,13.73,0,8.7-5.715,13.86-15.309,13.86h-7.09a1.621,1.621,0,0,1-1.622-1.62Zm8.88,23.412c7.762,0,12.153-4.093,12.153-11.214,0-7.036-4.521-11.259-12.11-11.259h-6.024V54.321Z",
    transform: "translate(-484.86 -29.29)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M320.4,55.191c-2.036,0-12.2-.7-12.2-14.48s10.161-14.48,12.2-14.48c1.517,0,6.707.334,9.841,4.637a1.013,1.013,0,0,1-.222,1.414l-.629.457a1.013,1.013,0,0,1-1.414-.222c-2.354-3.233-6.4-3.486-7.576-3.486-2.2,0-9.4.842-9.4,11.678s7.193,11.678,9.4,11.678c2.07,0,8.658-.647,9.339-8.712H320.4a1.013,1.013,0,0,1-1.013-1.013v-.777a1.013,1.013,0,0,1,1.013-1.013h11.187a1.013,1.013,0,0,1,1.013,1.013v.39c0,6.44-2.923,9.572-5.379,11.064A13.572,13.572,0,0,1,320.4,55.191Z",
    transform: "translate(-308.2 -26.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M443.67,29.852c0-.853.426-1.322,1.237-1.322h.383a1.161,1.161,0,0,1,1.279,1.322V55.138c0,.9-.426,1.322-1.279,1.322h-.383c-.811,0-1.237-.426-1.237-1.322Z",
    transform: "translate(-413.323 -28.015)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.936 36.34)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M313.177,199.91a2.1,2.1,0,0,0,2,1.1c1.248,0,1.85-.647,1.85-1.92v-.741a2.415,2.415,0,0,1-2.047.995,2.559,2.559,0,0,1-2.6-2.787,2.687,2.687,0,0,1,2.648-2.834,2.371,2.371,0,0,1,2.014.961v-.139c0-.6.22-.728.475-.728a.385.385,0,0,1,.267.081v5.195a2.335,2.335,0,0,1-2.614,2.592c-1.561,0-2.428-.833-2.428-1.3C312.738,199.99,313.155,199.862,313.177,199.91Zm1.886-1.216a1.91,1.91,0,0,0,1.978-1.736v-1.284a2,2,0,0,0-1.956-1.295,1.971,1.971,0,0,0-1.942,2.164A1.914,1.914,0,0,0,315.064,198.693Z",
    transform: "translate(-312.38 -192.539)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M348.415,193.72a2.519,2.519,0,0,1,2.567,2.778v.069c0,.208-.081.255-.311.255H346.39a2.033,2.033,0,0,0,2.095,2.014,1.983,1.983,0,0,0,1.886-.983.445.445,0,0,1,.439.428c0,.381-.833,1.225-2.325,1.225a2.733,2.733,0,0,1-2.845-2.87A2.766,2.766,0,0,1,348.415,193.72Zm1.77,2.453a1.733,1.733,0,0,0-1.77-1.794,2.012,2.012,0,0,0-2,1.794Z",
    transform: "translate(-338.189 -192.539)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M377.127,190.439h-.509c-.278,0-.358-.1-.358-.3v-.069c0-.2.081-.3.358-.3h.509v-.961c0-.278.139-.358.336-.358h.083c.2,0,.323.081.323.358v.961h1.47c.278,0,.358.105.358.3v.069c0,.2-.083.3-.358.3h-1.47v3.136c0,.811.208,1.192.822,1.192a1.052,1.052,0,0,0,.856-.405c.022-.022.255.081.255.37,0,.314-.405.683-1.134.683-1.075,0-1.539-.614-1.539-1.759v-3.217Z",
    transform: "translate(-361.95 -188.45)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M468.522,185.271a2.334,2.334,0,0,1,2,.972v-3.123a.344.344,0,0,1,.253-.081c.255,0,.5.128.5.728V190.6c0,.278-.139.358-.336.358h-.081c-.2,0-.325-.081-.325-.358V190a2.414,2.414,0,0,1-2.059,1.053,2.905,2.905,0,0,1,.049-5.784Zm.034,5.125a1.939,1.939,0,0,0,1.978-1.77v-1.4a2.1,2.1,0,1,0-1.978,3.17Z",
    transform: "translate(-430.55 -147.912)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M501.985,193a2.892,2.892,0,1,1-2.845,2.881A2.779,2.779,0,0,1,501.985,193Zm0,5.125a2.239,2.239,0,1,0-2.081-2.245A2.113,2.113,0,0,0,501.985,198.125Z",
    transform: "translate(-456.367 -155.641)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M533.682,193.585a.347.347,0,0,1,.255-.081c.255,0,.486.128.486.728v.186a2.163,2.163,0,0,1,1.875-1.008c1.456,0,2.186.972,2.186,2.431v2.9c0,.278-.139.358-.336.358h-.083c-.2,0-.336-.081-.336-.358v-2.858c0-1.1-.542-1.77-1.481-1.77a1.947,1.947,0,0,0-1.817,1.167v3.459c0,.278-.139.358-.336.358h-.081c-.2,0-.336-.081-.336-.358v-5.157Z",
    transform: "translate(-483.169 -155.959)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.095 35.609)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M415.76,185.73c0-.356.172-.54.506-.54h.161c.345,0,.517.184.517.54v6.456c0,.356-.173.54-.517.54h-.161c-.334,0-.506-.184-.506-.54Z",
    transform: "translate(-415.76 -185.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M428.687,186.34h-2.036c-.356,0-.551-.184-.551-.506v-.058c0-.323.195-.5.551-.5h5.271c.356,0,.54.172.54.5v.058a.471.471,0,0,1-.54.506h-2.036v5.892a.477.477,0,0,1-.529.54H429.2c-.334,0-.506-.184-.506-.54V186.34Z",
    transform: "translate(-423.784 -185.26)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGidLogo);
export default __webpack_public_path__ + "static/media/gid_logo.2411924e2b7219e98549a524b36a947e.svg";
export { ForwardRef as ReactComponent };